export default [
  {
    path: '/formas-pagamento',
    name: 'formas-pagamento',
    component: () => import(/* webpackChunkName: "faturas" */ '../../views/formasPagamento/Pagamento.vue')
  }
]
